export default __webpack_public_path__ + "static/media/shareHome.0a88123d.webp";